define([
    'text!product-detail/component/knowledge-group-item.html',

    'css!product-detail/component/knowledge-group-item.css'
], function(
    tpl
){
    return {
        template: tpl,
        props: {
            item: {
                type: Object
            },
            isOpen: {
                type: Boolean
            }
        },
        computed: {
            controlText: function(){
                return this.isOpen ? '-' : '+';
            },
            isPC: function () {
                if($(window).width()<=750){
                    $('.fixed-menu').css({display: 'none'});
                    return false;
                }else {
                    return true;
                }
            }
        },
        mounted: function(){
            var obj = this;
            $(window).resize( function  () {           //当浏览器大小变化时
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/knowledge-group-item.js
// module id = 199
// module chunks = 0